export const BOOM_URLS = {
	BOOM_MAIN: '/',
	BOOM_BRAND: '/brand',
	BOOM_DMCA: '/dmca',
};

export const SHARE_URLS = {
	SHARE_ALBUM: '/album/:id',
	SHARE_ARTIST: '/artist/:id',
	SHARE_PLAYLIST: '/playlist/:id',
	SHARE_TRACK: '/track/:id',
	SHARE_USER: '/user/:id',
};

export const URLS = {
	...BOOM_URLS,
	...SHARE_URLS,
};

export const UPLOAD_URL = {
	DMCA_UPLOAD_FILE: '/dmca_claim/file/:name',
};

export const API_URL = {
	DMCA_SUBMIT: '/dmca_claim/',

	SUBSCRIPTIONS_PRESENTATION_AVAILABLE_CAROUSEL: '/subscription/presentation/available_carousel',
	SUBSCRIPTIONS_PRESENTATION_ORDER_DETAILS: '/subscription/presentation/order_details',
	SUBSCRIPTIONS_PROVIDER: '/subscription/:provider/',
	SUBSCRIPTIONS_PROVIDER_SEND_CODE: '/subscription/:provider/send_code/',
	SUBSCRIPTIONS_PROVIDER_AVAILABLE_SERVICES: '/subscription/:provider/available_services/',

	STAT_CLIENT_INFO: '/clickstat/web_client_info',
	STAT_LOGS: '/stat/Logs/',

	ALBUM: '/album/:id',
	ALBUM_SHARE: '/share/album/:id',

	ARTIST: '/artist/:id',
	ARTIST_SHARE: '/share/artist/:id',

	USER_INFO: '/user/:id/info',
	USER_INFO_SHARE: '/share/user/:id/info',

	PLAYLIST: '/playlist/:id',
	PLAYLIST_SHARE: '/share/playlist/:id',

	TRACKS: '/track/:id',
	TRACKS_SHARE: '/share/track/:id',
};
